import React, { FC } from 'react';
import styles from './HTMLContent.module.scss';

export interface HTMLContentProps {
  htmlContent: string;
}

const HTMLContent: FC<HTMLContentProps> = ({ htmlContent }) => {
  return (
    <div className={styles.container}>
      <div className={styles.containerInner}>
        <div className={styles.htmlContent}>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
      </div>
    </div>
  );
};

export default HTMLContent;
